import * as React from 'react';
import { ThemeProvider } from 'styled-components';

import theme from 'styles/theme';

/**
 * @link https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#wrapRootElement
 * @link https://www.gatsbyjs.com/docs/reference/config-files/gatsby-ssr/#wrapRootElement
 */
export default function wrapRootElement({ element }) {
  return <ThemeProvider theme={theme}>{element}</ThemeProvider>;
}
